<script>
import { createFromIconfontCN } from '@ant-design/icons-vue'

export default createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_4137391_61d1z7uqzrk.js',
  extraCommonProps: {
    class: 'icon'
  }
})
</script>
